/**
 * How an engagement runs.
 *
 * Four stages, and the promise underneath them is the one that matters to
 * somebody deciding whether to risk a first payment: you can stop after any
 * stage and keep what was produced. That is why each stage is a numbered cell
 * rather than a connected timeline — a timeline implies you are committing to
 * the whole line.
 *
 * The discovery rate is printed here rather than left to the engagement
 * section, because it is the number that decides whether someone starts.
 */
import { Section } from '../components/Section';
import { useI18n } from '../i18n';
import { RATES } from '../lib/constants';
import styles from './Method.module.css';

export function Method() {
  const { t, locale } = useI18n();

  return (
    <Section
      id="method"
      eyebrow={t.method.eyebrow}
      title={t.method.title}
      lead={t.method.lead}
      tone="paper"
    >
      <ol className={`grid ${styles.grid}`}>
        {t.method.stages.map((stage, index) => (
          <li key={stage.label} className="cell">
            <p className={styles.label}>
              <span className={styles.num}>{stage.num}</span>
              <span aria-hidden="true"> · </span>
              {stage.label}
            </p>
            <h3 className={styles.title}>{stage.title}</h3>
            {index === 0 ? <p className={styles.price}>{RATES[locale].discovery}</p> : null}
            <p className={styles.body}>{stage.body}</p>
          </li>
        ))}
      </ol>
    </Section>
  );
}
